import { useMutation, useQuery } from "@tanstack/react-query";
import { CommunityDto, UserCommunityDto } from "../../services/dto";
import { SearchDto } from "../../assets/utils/lib/searchDto";
import { IActionResponse, IActionResult } from "../../services/proxies";
import { CommunityClient } from "../../services/proxies/community/communityClient";
import { ViewProps } from "./props";
import { QueryKeyTypes } from "../../assets/types";
import { Constants } from "../../assets/utils/lib/constants";

export namespace CommunityService {
  const communityClient = new CommunityClient();

  export const save = () =>
    useMutation<IActionResult<CommunityDto>, Error, CommunityDto>({
      mutationFn: async (payload: CommunityDto) => {
        return await communityClient.saveCommunityAsync(payload);
      },
    });

  export const getCommunityQuery = (CommunityId: string | undefined) =>
    useQuery({
      queryKey: [ViewProps.CommunityQueryKeys[QueryKeyTypes.Get], CommunityId],
      queryFn: async () => await communityClient.getCommunityAsync(CommunityId),
      enabled: Boolean(CommunityId) && CommunityId !== Constants.emptyGuid && CommunityId !== undefined,
    });

  export const gridQuery = (searchQuery: SearchDto, enabled: boolean = true) =>
    useQuery({
      queryKey: [ViewProps.CommunityQueryKeys[QueryKeyTypes.Grid], searchQuery],
      queryFn: async () =>
        await communityClient.searchCommunitiesAsync(searchQuery),
      enabled: enabled,
    });

  export const deActivateCommunity = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (communityId: string | undefined): Promise<IActionResponse> => {
        return await communityClient.deActivateCommunityAsync(communityId);
      },
    });

  export const getLookups = () =>
    useQuery({
      queryKey: [ViewProps.CommunityQueryKeys[QueryKeyTypes.Lookup]],
      queryFn: async (): Promise<ViewProps.CommunityLookupProps> =>
        await communityClient.getLookupsAsync(),
    });

  export const getCommunitiesQuery = () =>
    useQuery({
      queryKey: [ViewProps.CommunityQueryKeys[QueryKeyTypes.GetAll]],
      queryFn: async () => await communityClient.getCommunitiesAsync(),
    });

  export const getUserCommunities = () =>
    useQuery({
      queryKey: ["userCommunitiesQuery"],
      queryFn: async (): Promise<UserCommunityDto[]> =>
        await communityClient.getUserCommunitiesAsync(),
    });
}
